import {Component} from 'react';
import Server from '../../services/Server';
import styles from './Action.module.scss';

import {FirstBlock, FirstMemory, SecondBlock, FirstTest, SecondTest, ThirdBlock, SberFirstBlock, SberSecondBlock, SberThirdBlock} from "../../layouts";

export class Action extends Component {
    state = {
        step: 0,
        email: '',
        type: true,
        answer: '',
        currentAnswer: 'подружимся'
    }

    verification = (handler) => {
        if (this.state.step === 2) {
            if (this.state.email !== '' && this.state.email.length > 3) {
                handler(true);
            } else {
                handler(false);
            }
        } else if (this.state.step === 6) {
            document.querySelector('.input-answer').classList.remove('error');
            if (this.state.answer !== '') {
                handler(true);
            } else {
                handler(false);
            }
        }
    }

    onChange = (event, name, handler) => {
        this.setState({
            [name]: event
        }, () => {
            if (name === "email") {
                document.querySelector('.input-email').classList.remove('error');
                if (/vk.com\//.test(event)) {
                    this.setState({ type: true });
                } else {
                    this.setState({ type: false });
                }
                this.verification(handler);
            } else if (name === "answer") {
                this.verification(handler);
            }
        })
    }

    handler = (type) => {
        document.querySelector('.finish-button').classList.remove('retry');
        document.querySelector('.finish-button').classList.remove('error');

        if (type === 'success') {
            this.nextStep();
        } else if (type === 'retry') {
            document.querySelector('.finish-button').classList.add('retry');
        } else if (type === 'error') {
            document.querySelector('.finish-button').classList.add('error');
        }
    }

    click = () => {
        Server(`${process.env.PUBLIC_URL}/ajax.php`, {'LINK': this.state.email}, this.handler);
    }

    nextStep = () => {
        this.props.checkoutState(this.state.step + 1);

        this.setState(({step}) => ({
            step: ++step
        }));
    }

    render() {
        const {step} = this.state;
        const currentContent = [
            <FirstBlock handler={this.nextStep}/>,
            <FirstMemory handler={this.nextStep}/>,
            <SecondBlock handler={this.nextStep} type={this.state.type} onChange={this.onChange} emailValue={this.state.email}/>,
            <SberFirstBlock handler={this.nextStep}/>,
            <FirstTest handler={this.nextStep} />,
            <SecondTest handler={this.nextStep}/>,
            <ThirdBlock handler={this.nextStep} onChange={this.onChange} answerValue={this.state.answer} currentAnswer={this.state.currentAnswer}/>,
            <SberSecondBlock finished={this.click} handler={this.nextStep}/>,
            <SberThirdBlock handler={this.nextStep}/>,
        ]

        return (
            <div className={styles.action}>
                {currentContent[step]}
            </div>
        )
    }
}